const initialOptions = {
    "client-id": "AZllL-OpvDUHCZQdf0OmN3jLf4s1aaiqXwizC3XMABjoaO_97Gbj_aXMdHt5cvkXaw7BGAzxWZPv7WBI",
    currency: "USD",
    intent: "capture",
};

export default initialOptions;

// OpvDUHCZQdf0OmN3jLf4s1aaiqXwizC3XMABjoaO_97Gbj_aXMdHt5cvkXaw7BGAzxWZPv7WBI